"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _ikon = _interopRequireDefault(require("./ikon"));
const Share = _ref => {
  let {
    title = 'Share',
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, props, {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 30"
  }), /*#__PURE__*/_react.default.createElement("title", null, title), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.7272025,3.7898659 C12.7272025,4.2857436 12.8147971,4.7668425 12.9828862,5.2010474 L6.0701066,9.1976263 C5.4237987,8.5882554 4.5715195,8.2107972 3.6363912,8.2107972 C1.6347094,8.2107972 0,9.9143011 0,12.000221 C0,14.086141 1.6347094,15.7896449 3.6363912,15.7896449 C4.5762771,15.7896449 5.4332836,15.4171129 6.0795915,14.8028158 L12.9923712,18.7993947 C12.8219153,19.2372942 12.7272176,19.7109722 12.7272176,20.2105762 C12.7272176,22.2964961 14.361927,24 16.3636088,24 C18.3652906,24 20,22.2964961 20,20.2105762 C20,18.1246563 18.3652906,16.4211524 16.3636088,16.4211524 C15.2745703,16.4211524 14.2944719,16.9269141 13.6268608,17.7237668 L6.8371124,13.796029 C7.1152872,13.2606781 7.2727218,12.6488441 7.2727218,12 C7.2727218,11.3486928 7.1176539,10.7405534 6.8371124,10.203971 L13.6268608,6.2762332 C14.2944719,7.0743174 15.2734187,7.5788476 16.3636088,7.5788476 C18.3652906,7.5788476 20,5.8753437 20,3.7894238 C20,1.7035039 18.3652906,0 16.3636088,0 C14.3619118,0.0004421 12.7272025,1.703946 12.7272025,3.7898659 Z"
  }));
};
var _default = exports.default = (0, _ikon.default)(Share);
Share.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Share",
  "props": {
    "title": {
      "defaultValue": {
        "value": "'Share'",
        "computed": false
      },
      "required": false
    }
  }
};